import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';
import { Messages } from '../../../codegen/Localize';
import { ToasterService, ToastType } from '../../../ts/services/ToasterService';

/**
 * Save and Revert
 */
const saveAndRevertStyle = style({
  padding: 5,
  paddingLeft: 500,
  borderBottom: `1px solid ${TabStyles.Colors.L2_5}`,
  background: 'white',
  display: 'flex',
});

export interface SaveRevertButtonProps {
  triggerSave: () => Promise<unknown>;
  triggerRevert: () => Promise<void>;
  isAnyDirty: boolean;
  isAnyInvalid: boolean;
  isAnySubmitting: boolean;
}

/**
 * Responsible for triggering submit / cancel in a Formik form and showing toasts
 */
export function SaveAndRevertButtons(props: SaveRevertButtonProps) {

  const revertCallback = React.useCallback(async () => {
    await props.triggerRevert();
    ToasterService.instance.pop({type: ToastType.Info, text: Messages.settingsReverted()});
  }, [props.triggerRevert]);

  return (
    <div className={saveAndRevertStyle}>
      <ButtonWidget
        testId={'revert-settings'} buttonType={ButtonType.Outline}
        disabled={!props.isAnyDirty || props.isAnySubmitting} onClick={revertCallback}
        style={{marginRight: 20}}
      >
        {Messages.revert()}
      </ButtonWidget>

      <ButtonWidget
        testId={'save-settings'}
        buttonType={ButtonType.Primary}
        disabled={props.isAnyInvalid || !props.isAnyDirty || props.isAnySubmitting}
        onClick={props.triggerSave}
      >
        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {<span style={{
            visibility: props.isAnySubmitting ? null : 'hidden',
            marginLeft: '-35%',
            marginRight: '10%',
          }}>
            <ActivitySpinnerWidget testId={'save-button-spinner'} spinnerSize={ActivitySpinnerSize.Small}/>
          </span>}
          {Messages.save()}
        </span>
      </ButtonWidget>
    </div>
  );
}
